import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, {ReactNode} from 'react';

import getTestProps from 'test/lib/cypress/getTestProps';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';

export interface NycRowProps {
  children?: ReactNode;
  className?: string;
  fluid?: boolean;
  style?: React.CSSProperties;
  dataTestAttrs?: DataTestAttrs;
}

export function Row(props: NycRowProps): JSX.Element {
  return (
    <div
      className={classNames('nyc-row', props.className, {'nyc-row--fluid': props.fluid})}
      style={props.style}
      {...getTestProps(props.dataTestAttrs)}
    >
      {props.children}
    </div>
  );
}

Row.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  fluid: PropTypes.bool,
  style: PropTypes.object,
};

export interface NycColProps {
  children?: ReactNode;
  className?: string;
  sm?: number;
  md?: number;
  lg?: number;
}

export function Col(props: NycColProps): JSX.Element {
  const classes = [];
  if (props.sm) {
    classes.push(`nyc-col-sm-${props.sm}`);
  }
  if (props.md) {
    classes.push(`nyc-col-md-${props.md}`);
  }
  if (props.lg) {
    classes.push(`nyc-col-lg-${props.lg}`);
  }
  if (classes.length === 0) {
    // Default to sm-1 if nothing is specified
    classes.push('nyc-col-sm-1');
  }
  return <div className={classNames(classes, props.className)}>{props.children}</div>;
}

Col.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  sm: PropTypes.number,
  md: PropTypes.number,
  lg: PropTypes.number,
};

export interface NycContainerProps {
  children?: ReactNode;
  className?: string;
  size: 'sidepanel' | 'sm' | 'md' | 'lg';
  dataTestAttrs?: DataTestAttrs;
}

export function Container(props: NycContainerProps): JSX.Element {
  const classes = {
    'nyc-container': true,
    'nyc-container-sidepanel': props.size === 'sidepanel',
    'nyc-container-sm': props.size === 'sm',
    'nyc-container-md': props.size === 'md',
    'nyc-container-lg': props.size === 'lg',
  };
  return (
    <div
      className={classNames(props.className, classes)}
      {...(props.dataTestAttrs ? getTestProps(props.dataTestAttrs) : {})}
    >
      {props.children}
    </div>
  );
}

Container.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sidepanel', 'sm', 'md', 'lg']).isRequired,
};
